import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { PatientMedicationPage } from '../patient-medication/patient-medication';
import { PatientAddPage } from '../patient-add/patient-add';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/forkJoin';  
import 'rxjs/add/operator/mergeMap';
import { FirestoreProvider } from '../../providers/firestore/firestore';
import * as moment from "moment";
import _ from 'lodash';
import { AuthProvider } from '../../providers/auth/auth';
import { DatabaseProvider } from '../../providers/database/database';
import { SurveyPage } from '../survey/survey';

@IonicPage()
@Component({
  selector: 'page-patient-details',
  templateUrl: 'patient-details.html',
})
export class PatientDetailsPage {

  patient: any;
  fullname: string = null;
  insuranceImage: any = null;
  doctor: any;
  prescriptions = [];
  study: any;
  public patientStudy: Observable<any[]>;
  public patientDetails: Observable<any>;
  public patientOrders: Observable<any[]>;
  clinic_name: string;
  clinic_id: string;

  clinic: any;

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams, 
    public alertCtrl: AlertController, 
    private iab: InAppBrowser,
    public firestoreProvider: FirestoreProvider,
    private database: DatabaseProvider,
    private auth: AuthProvider,
    public modalCtrl: ModalController
  ) {
    this.patient = this.navParams.get('patient');
    this.fullname = this.patient['first_name'] + ' ' + this.patient['last_name'];
    this.auth.getCurrentUser().then(user => {
      console.log(user);
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.database.getPatientFromClinic(this.clinic_id, this.patient.id).valueChanges().subscribe((patient) => {
        if(patient)  {
          patient['id'] = this.patient.id;
          this.patient = patient;
          this.patient.age = this.getAge(this.patient.dob);
        }
      });

      this.patientStudy = this.database.getStudiesByPatient(this.clinic_id, this.patient.id)
      .snapshotChanges()
        .map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as any;
            data.id = a.payload.doc.id;
            return data;
          });
        });
        
      this.patientStudy.subscribe((data) => {
        console.log("Patient Study: ", data)
        this.patient['study'] = {};
        this.patient.study['completed'] = false;
        this.patient.study['name'] = null;
        this.patient.study['createdAt'] = null;
        this.patient.study['updatedAt'] = null;
        if(data.length > 0)  {
          this.patient.study.completed = true;
          this.patient.study.name = data[0].study[0].name;
          if(data[0].updatedAt) this.patient.study.updatedAt = data[0].updatedAt.toDate();
          if(data[0].createdAt) this.patient.study.createdAt = data[0].createdAt.toDate();
          // this.study = data[0];
          console.log(this.patient)
        }
        else {
          this.patient.study.completed = false;
          this.patient.study.name = null;
          this.patient.study.updatedAt = null;
          this.patient.study.createdAt = null;
        }
      })

      this.database.getClinic(this.clinic_id).valueChanges().subscribe((clinic) => {
        if(clinic)  {
          this.clinic = clinic;
          console.log("Full Clinic Info: ", this.clinic)
          if(this.clinic.regatta_override)  {
            this.database.getStudyById(this.clinic.regatta_override).valueChanges().subscribe((study) => {
              this.study = study;
            })
          } else {
            this.database.getStudyById('regatta').valueChanges().subscribe((study) => {
              this.study = study;
            })
          }
          
        }
      });
      
      this.patientOrders = this.database.getPrescriptionsbyPatient(this.clinic_id, this.patient.id).snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      });
    });
  }

  openPrescriptionImage(imageUrl)  {
    console.log(imageUrl);
    let browser = this.iab.create(imageUrl, '_blank', {
      closebuttoncaption: "Exit",
      enableViewportScale: "yes"
    });
  }

  addPrescription() {
    let patientdata = {
      patient: this.patient,
      doctor: this.doctor,
      existingpatient: true
    };
    this.navCtrl.push(PatientMedicationPage, patientdata);
  }

  deletePatient() {
    let confirm = this.alertCtrl.create({
      title: "Delete Patient",
      message: "Are you sure you want to delete this patient?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't delete the patient right now");
          }
        },
        {
          text: "Yes",
          handler: () => {
            console.log("Delete patient: ", this.patient.id)

            this.database.deletePatient(this.clinic_id, this.patient.id).then((val) => {
              console.log("Delete clinic success: ");
              this.navCtrl.pop();
            })
            .catch((err) => {
              console.log("Delete clinic error: ", err);
            })

          }
        }
      ]
    });
    confirm.present();
  }

  getAge(dateString) {
    console.log(dateString)
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

  editPatient() {
    let patientdata = {
      patient: this.patient
    };
    this.navCtrl.push(PatientAddPage, patientdata);
  }

  public formatDate(date) {
    let myMoment: moment.Moment
    if (date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("YYYY MMM DD");
  }

  CompleteStudy(study)  {
    let studydata = {
      clinic: this.clinic,
      patient: study.patient,
      doctor: study.doctor,
      medication: study.medication,
      study: [this.study],
      renewal: false
    };

    let studyModal = this.modalCtrl.create(SurveyPage, studydata, {cssClass: 'select-modal', enableBackdropDismiss: false });
    studyModal.onDidDismiss(data => {
      console.log(data)
      if(data['completed'])  {
        this.database.completeStudy(study.id, this.clinic_id, data.patient_id, data)
      }      
    });
    studyModal.present();
  }

  viewConsent(url)  {
    this.iab.create(url);
  }


}



// WEBPACK FOOTER //
// ./src/pages/patient-details/patient-details.ts